module.exports = {
  // title: '机械工业500强申报平台',
  title: '导萃门诊管理系统',
  // imgUrl: require('./assets/ik/images/logo.png')
  imgUrl: 'helog.png'
}
